module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-container"
  }, [_c('nav', _vm._l((_vm.tabs), function(tab, i) {
    return _c('router-link', {
      key: "{i}",
      class: {
        active: _vm.index === i
      },
      attrs: {
        "to": tab.path
      },
      nativeOn: {
        "click": function($event) {
          _vm.linkTo(i)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view', {
    attrs: {
      "keep-alive": ""
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-94c3375e"}!./~/._vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/app/index.vue
// module id = 165
// module chunks = 1